import { render, staticRenderFns } from "./BarChartAlarmeJeBereich.vue?vue&type=template&id=c228c22a"
import script from "./BarChartAlarmeJeBereich.vue?vue&type=script&lang=js"
export * from "./BarChartAlarmeJeBereich.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports